import styled from 'styled-components';

export const ReserveSettingsContainer = styled.div`
    width: 100%;
    display: block;
    margin: 30px 0;
`;

export const ReserveSettingsGenerateReportContainer = styled.div`
    width: 100%;
    margin-bottom: 30px;
    display: flex;
    justify-content: space-around;
`;

export const RSColumn = styled.div`
    display: inline-block;
    width: 50%;
`;
export const RSLoanFormat = styled.div`
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 5px;
`;
export const RSMaxCopiesRow = styled.div`
    display: inline-block;
    font-size: 14px;
    .default-dd {
        width: 90px;
    }
`;
export const RSFieldName = styled.span`
    &:after {
        content: ' ';
    }
`;
export const RSFieldValue = styled.span`
    font-weight: 600;
`;
